// 手动引入 ECharts 各模块来减小打包体积
import * as echarts from 'echarts';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import {
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import type { App } from 'vue';
import VChart, { THEME_KEY } from 'vue-echarts';
import theme from './echart-theme.json';

use([
  CanvasRenderer,
  BarChart,
  PieChart,
  LineChart,
  GridComponent,
  TooltipComponent,
  ToolboxComponent,
]);
echarts.registerTheme('default', theme);

export default function InitEchart(app: App) {
  app.component('VChart', VChart);
  app.provide(THEME_KEY, 'default');
  app.mixin({
    mounted() {
      window.addEventListener('resize', this.handleWindowResize);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.handleWindowResize);
    },
    methods: {
      handleWindowResize() {
        this.$nextTick(() => {
          const refNames = Object.keys(this.$refs);
          refNames.forEach((ref: any) => {
            if (ref.toLowerCase().includes('chart')) {
              this?.$refs[ref]?.resize && this?.$refs[ref].resize();
            }
          });
        });
      },
    },
  });
}
